import type { ShipRoute } from "../../../../common/types/shipRoute";
import { BaseService } from "@/api/baseService";
import httpRequest from "@/api/index";

export class ShipRouteServcie extends BaseService<ShipRoute, any, any, any> {
    async getShipRoute(startPortId: number, endPortId: number): Promise<ShipRoute[]> {
        const { data } = await this.service.get(`${this.path}/${startPortId}/${endPortId}`);
        return data;
    }
}
export const shipRouteServcie = new ShipRouteServcie("/ship/route", httpRequest);
